import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import AddUser from 'shared/images/empty_baggage.webp'
import { ButtonAddCircle } from 'shared/ui/button-add-circle'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  isShowButton?: boolean
}

export const EmptyPage: FC<Props> = ({ isShowButton }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onNavigate = () => {
    navigate(RoutingPaths.closeCircle.form.path())
  }

  return (
    <div className={s.wrapper}>
      <ImageLazy
        alt=""
        src={AddUser}
      />

      <h3>{t('circle_empty_title')}</h3>
      <p>{t('circle_empty_description')}</p>
      {isShowButton ? (
        <ButtonAddCircle
          onClick={onNavigate}
          content={t('add_close')}
          leftIcon={true}
        />
      ) : null}
    </div>
  )
}
